import { Model } from '@vuex-orm/core'

export default class JobLog extends Model {
  // This is the name used as module name of the Vuex Store.
  static entity = 'jobLogs'

  static primaryKey = '_id'

  // List of all fields (schema) of the post model. `this.attr` is used
  // for the generic field type. The argument is the default value.
  static fields () {
    return {
      _id: this.attr(null),
      note: this.attr(null),
      fixed: this.attr(null),
      job_id: this.attr(null),
      author_user_id: this.attr(null),
      account_id: this.attr(null),
      created_at: this.attr(null),
      updated_at: this.attr(null)
    }
  }
}



// WEBPACK FOOTER //
// ./src/models/JobLog.js